import { gql } from "@apollo/client";

export const DELETE_COACH_BIO_MUTATION = gql`
  mutation DeleteCoachBio($userUuid: String!, $uniqueBioIds: [String!]!) {
    deleteCoachBio(userUuid: $userUuid, uniqueBioIds: $uniqueBioIds) {
      returnMessage {
        status
        message
      }
    }
  }
`;

export interface DeleteCoachBioData {
  deleteCoachBio: {
    returnMessage: {
      status: string;
      message: string;
    };
  };
}

export interface DeleteCoachBioVariables {
  userUuid: string;
  uniqueBioIds: Array<string>;
}
